(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-about-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const markVisible = (items) => items.forEach((item) => item && item.classList.add('is-visible'));
    const afterPaint = (callback) => requestAnimationFrame(() => {
      requestAnimationFrame(callback);
    });

    const waitForImage = (image) => {
      if (!image) return Promise.resolve();
      if (image.complete) {
        if (typeof image.decode === 'function') return image.decode().catch(() => undefined);
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        const done = () => resolve();
        image.addEventListener('load', done, { once: true });
        image.addEventListener('error', done, { once: true });
      });
    };

    const replayHero = (root) => {
      const heroImage = root.querySelector('.ox-about-v3__hero>picture>img[data-ox-about-reveal]');
      const heroCopy = root.querySelector('[data-ox-about-hero-copy]');
      const heroItems = [heroImage, heroCopy].filter(Boolean);
      if (!heroItems.length) return;

      const replayToken = String((Number(root.dataset.oxHeroReplay || 0) + 1));
      root.dataset.oxHeroReplay = replayToken;
      root.classList.add('ox-about-v3--reveal-ready');
      heroItems.forEach((item) => item.classList.remove('is-visible'));

      if (reduceMotion()) {
        markVisible(heroItems);
        return;
      }

      afterPaint(() => {
        if (root.dataset.oxHeroReplay !== replayToken) return;
        markVisible([heroCopy]);
      });

      waitForImage(heroImage).then(() => {
        if (root.dataset.oxHeroReplay !== replayToken) return;
        afterPaint(() => {
          if (root.dataset.oxHeroReplay !== replayToken) return;
          markVisible([heroImage]);
        });
      });
    };

    const initialiseAboutReveals = () => {
      document.querySelectorAll('.ox-about-v3:not([data-ox-reveal-bound])').forEach((root) => {
        root.setAttribute('data-ox-reveal-bound', 'true');
        root.classList.add('ox-about-v3--reveal-ready');
        const items = Array.from(root.querySelectorAll('[data-ox-about-reveal]'));
        const heroImage = root.querySelector('.ox-about-v3__hero>picture>img[data-ox-about-reveal]');
        const heroCopy = root.querySelector('[data-ox-about-hero-copy]');

        if (reduceMotion() || !('IntersectionObserver' in window)) {
          markVisible([...items, heroCopy]);
          return;
        }

        replayHero(root);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAboutReveals, { once: true });
    else initialiseAboutReveals();
    document.addEventListener('shopify:section:load', initialiseAboutReveals);
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      document.querySelectorAll('.ox-about-v3').forEach((root) => replayHero(root));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-brand-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const markVisible = (items) => items.forEach((item) => item && item.classList.add('is-visible'));
    const afterPaint = (callback) => requestAnimationFrame(() => {
      requestAnimationFrame(callback);
    });

    const waitForImage = (image) => {
      if (!image) return Promise.resolve();
      if (image.complete) {
        if (typeof image.decode === 'function') return image.decode().catch(() => undefined);
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        const done = () => resolve();
        image.addEventListener('load', done, { once: true });
        image.addEventListener('error', done, { once: true });
      });
    };

    const replayHero = (root) => {
      const heroImage = root.querySelector('.ox-brand__hero>img[data-ox-brand-reveal]');
      const heroCopy = root.querySelector('[data-ox-brand-hero-copy]');
      const heroItems = [heroImage, heroCopy].filter(Boolean);
      if (!heroItems.length) return;

      const replayToken = String((Number(root.dataset.oxHeroReplay || 0) + 1));
      root.dataset.oxHeroReplay = replayToken;
      root.classList.add('ox-brand--reveal-ready');
      heroItems.forEach((item) => item.classList.remove('is-visible'));

      if (reduceMotion()) {
        markVisible(heroItems);
        return;
      }

      afterPaint(() => {
        if (root.dataset.oxHeroReplay !== replayToken) return;
        markVisible([heroCopy]);
      });

      waitForImage(heroImage).then(() => {
        if (root.dataset.oxHeroReplay !== replayToken) return;
        afterPaint(() => {
          if (root.dataset.oxHeroReplay !== replayToken) return;
          markVisible([heroImage]);
        });
      });
    };

    const initialiseBrandReveals = () => {
      document.querySelectorAll('.ox-brand:not([data-ox-reveal-bound])').forEach((root) => {
        root.setAttribute('data-ox-reveal-bound', 'true');
        root.classList.add('ox-brand--reveal-ready');
        const items = Array.from(root.querySelectorAll('[data-ox-brand-reveal]'));
        const heroImage = root.querySelector('.ox-brand__hero>img[data-ox-brand-reveal]');
        const heroCopy = root.querySelector('[data-ox-brand-hero-copy]');

        if (reduceMotion() || !('IntersectionObserver' in window)) {
          markVisible([...items, heroCopy]);
          return;
        }

        replayHero(root);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseBrandReveals, { once: true });
    else initialiseBrandReveals();
    document.addEventListener('shopify:section:load', initialiseBrandReveals);
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      document.querySelectorAll('.ox-brand').forEach((root) => replayHero(root));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-ceramic-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const validSeries = new Set(['all', 'cafe', 'table', 'cadeaux']);
  const validTypes = new Set(['all', 'tasses-gobelets', 'tasses-soucoupes', 'bols', 'assiettes', 'plats-service']);

  document.querySelectorAll('[data-ox-series-catalog]').forEach((root) => {
    if (root.dataset.oxCatalogReady === 'true') return;
    root.dataset.oxCatalogReady = 'true';

    const seriesButtons = [...root.querySelectorAll('[data-ox-series-filter]')];
    const typeButtons = [...root.querySelectorAll('[data-ox-type-filter]')];
    const cards = [...root.querySelectorAll('[data-ox-catalog-card]')];
    const count = root.querySelector('[data-ox-catalog-count]');
    const pieceLabel = root.querySelector('[data-ox-catalog-piece-label]');
    const empty = root.querySelector('[data-ox-catalog-empty]');
    const sort = root.querySelector('[data-ox-catalog-sort]');
    let state = { series: 'all', type: 'all' };

    const readUrl = () => {
      const params = new URL(window.location.href).searchParams;
      const requestedSeries = params.get('series') || 'all';
      const requestedType = params.get('type') || 'all';
      return {
        series: validSeries.has(requestedSeries) ? requestedSeries : 'all',
        type: validTypes.has(requestedType) ? requestedType : 'all'
      };
    };

    const writeUrl = () => {
      const url = new URL(window.location.href);
      if (state.series === 'all') url.searchParams.delete('series');
      else url.searchParams.set('series', state.series);
      if (state.type === 'all') url.searchParams.delete('type');
      else url.searchParams.set('type', state.type);
      window.history.replaceState({}, '', url);
    };

    const applyState = (nextState, updateUrl = false) => {
      const series = validSeries.has(nextState.series) ? nextState.series : 'all';
      let type = validTypes.has(nextState.type) ? nextState.type : 'all';
      const seriesCards = cards.filter((card) => {
        const seriesValues = (card.dataset.oxSeries || '').split(/\s+/).filter(Boolean);
        return series === 'all' || seriesValues.includes(series);
      });
      if (type !== 'all') {
        const hasSelectedType = seriesCards.some((card) => {
          const typeValues = (card.dataset.oxTypes || '').split(/\s+/).filter(Boolean);
          return typeValues.includes(type);
        });
        if (!hasSelectedType) type = 'all';
      }
      state = { series, type };

      seriesButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.seriesValue === series));
      });
      typeButtons.forEach((button) => {
        const buttonType = button.dataset.typeValue;
        const available = buttonType === 'all' || seriesCards.some((card) => {
          const typeValues = (card.dataset.oxTypes || '').split(/\s+/).filter(Boolean);
          return typeValues.includes(buttonType);
        });
        button.hidden = !available;
        button.setAttribute('aria-pressed', String(buttonType === type));
      });

      const visibleCards = [];
      cards.forEach((card) => {
        const seriesValues = (card.dataset.oxSeries || '').split(/\s+/).filter(Boolean);
        const typeValues = (card.dataset.oxTypes || '').split(/\s+/).filter(Boolean);
        const visible = (series === 'all' || seriesValues.includes(series)) && (type === 'all' || typeValues.includes(type));
        card.hidden = !visible;
        if (visible) visibleCards.push(card);
      });

      if (count) count.textContent = String(visibleCards.length);
      if (pieceLabel) {
        pieceLabel.textContent = visibleCards.length === 1 ? pieceLabel.dataset.single : pieceLabel.dataset.plural;
      }
      if (empty) empty.hidden = visibleCards.length !== 0;
      if (updateUrl) writeUrl();
    };

    seriesButtons.forEach((button) => {
      button.addEventListener('click', () => applyState({ series: button.dataset.seriesValue, type: 'all' }, true));
    });
    typeButtons.forEach((button) => {
      button.addEventListener('click', () => applyState({ series: state.series, type: button.dataset.typeValue }, true));
    });

    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.assign(url.toString());
      });
    }

    window.addEventListener('popstate', () => applyState(readUrl()));
    applyState(readUrl());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-ceramic-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-orienx-home]');
    if (!root) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const reveals = root.querySelectorAll('[data-ox-reveal]');
    root.querySelectorAll('.ox-collection-card[data-ox-reveal]').forEach((item,index) => {
      item.style.setProperty('--ox-reveal-delay',`${(index % 3) * 50}ms`);
    });
    if (!reduced && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const item = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= .08) {
            item.classList.remove('is-reveal-edge');
            item.classList.add('is-visible');
            return;
          }
          if (entry.isIntersecting && entry.intersectionRatio > 0) {
            if (entry.intersectionRatio <= .025 && item.classList.contains('is-visible')) item.classList.add('is-reveal-edge');
            return;
          }
          item.classList.remove('is-visible','is-reveal-edge');
          if (item.matches('.ox-craft__scene')) return;
          const distance = window.matchMedia('(max-width:600px)').matches ? 8 : 12;
          item.style.setProperty('--ox-reveal-y',`${entry.boundingClientRect.bottom <= 0 ? -distance : distance}px`);
        });
      }, { threshold:[0,.025,.08], rootMargin:'0px' });
      reveals.forEach((item) => observer.observe(item));
    } else reveals.forEach((item) => item.classList.add('is-visible'));

    if (!reduced && window.matchMedia('(pointer:fine)').matches) {
      const applyMagnetic = (element,strength = 8) => {
        if (!element) return;
        element.addEventListener('pointermove',(event) => {
          const rect = element.getBoundingClientRect();
          element.style.setProperty('--mag-x',`${(event.clientX - rect.left - rect.width / 2) / strength}px`);
          element.style.setProperty('--mag-y',`${(event.clientY - rect.top - rect.height / 2) / strength}px`);
        });
        element.addEventListener('pointerleave',() => {
          element.style.setProperty('--mag-x','0px');
          element.style.setProperty('--mag-y','0px');
        });
      };
      root.querySelectorAll('[data-ox-magnetic]').forEach((element) => applyMagnetic(element,9));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-company-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const markVisible = (items) => items.forEach((item) => item && item.classList.add('is-visible'));
    const afterPaint = (callback) => requestAnimationFrame(() => {
      requestAnimationFrame(callback);
    });

    const waitForImage = (image) => {
      if (!image) return Promise.resolve();
      if (image.complete) {
        if (typeof image.decode === 'function') return image.decode().catch(() => undefined);
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        const done = () => resolve();
        image.addEventListener('load', done, { once: true });
        image.addEventListener('error', done, { once: true });
      });
    };

    const replayHero = (root) => {
      const heroImage = root.querySelector('.ox-company__hero>img[data-ox-company-reveal]');
      const heroCopy = root.querySelector('[data-ox-company-hero-copy]');
      const heroItems = [heroImage, heroCopy].filter(Boolean);
      if (!heroItems.length) return;

      const replayToken = String((Number(root.dataset.oxHeroReplay || 0) + 1));
      root.dataset.oxHeroReplay = replayToken;
      root.classList.add('ox-company--reveal-ready');
      heroItems.forEach((item) => item.classList.remove('is-visible'));

      if (reduceMotion()) {
        markVisible(heroItems);
        return;
      }

      afterPaint(() => {
        if (root.dataset.oxHeroReplay !== replayToken) return;
        markVisible([heroCopy]);
      });

      waitForImage(heroImage).then(() => {
        if (root.dataset.oxHeroReplay !== replayToken) return;
        afterPaint(() => {
          if (root.dataset.oxHeroReplay !== replayToken) return;
          markVisible([heroImage]);
        });
      });
    };

    const initialiseCompanyReveals = () => {
      document.querySelectorAll('.ox-company:not([data-ox-reveal-bound])').forEach((root) => {
        root.setAttribute('data-ox-reveal-bound', 'true');
        root.classList.add('ox-company--reveal-ready');
        const items = Array.from(root.querySelectorAll('[data-ox-company-reveal]'));
        const heroImage = root.querySelector('.ox-company__hero>img[data-ox-company-reveal]');
        const heroCopy = root.querySelector('[data-ox-company-hero-copy]');

        if (reduceMotion() || !('IntersectionObserver' in window)) {
          markVisible([...items, heroCopy]);
          return;
        }

        replayHero(root);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseCompanyReveals, { once: true });
    else initialiseCompanyReveals();
    document.addEventListener('shopify:section:load', initialiseCompanyReveals);
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      document.querySelectorAll('.ox-company').forEach((root) => replayHero(root));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-editorial-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-orienx-maison-page]');
    if (!root) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = root.querySelectorAll('[data-maison-reveal],.orienx-fragment');
    if (!reduced && 'IntersectionObserver' in window) {
      root.classList.add('maison-motion-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold:.06, rootMargin:'0px 0px -5% 0px' });
      revealItems.forEach((item,index) => {
        if (item.classList.contains('orienx-fragment')) item.style.transitionDelay = `${Math.min(index % 6,5) * 55}ms`;
        observer.observe(item);
      });
    } else revealItems.forEach((item) => item.classList.add('is-visible'));

    const filmDialog = root.querySelector('[data-film-dialog]');
    const filmPlayer = root.querySelector('[data-film-player]');
    const filmClose = root.querySelector('[data-film-close]');
    const closeFilm = () => { filmPlayer?.pause(); filmDialog?.close(); };
    root.querySelectorAll('[data-film-open]').forEach((button) => button.addEventListener('click',() => {
      if (!filmDialog || !filmPlayer || !button.dataset.filmSrc) return;
      filmPlayer.src = button.dataset.filmSrc;
      filmPlayer.poster = button.dataset.filmPoster || '';
      filmDialog.showModal();
      filmPlayer.play().catch(() => {});
    }));
    filmClose?.addEventListener('click',closeFilm);
    filmDialog?.addEventListener('click',(event) => { if (event.target === filmDialog) closeFilm(); });
    filmDialog?.addEventListener('cancel',(event) => { event.preventDefault(); closeFilm(); });

    const fragmentDialog = root.querySelector('[data-fragment-dialog]');
    const fragmentImage = root.querySelector('[data-fragment-image]');
    const fragmentCopy = root.querySelector('[data-fragment-copy]');
    const closeFragment = () => fragmentDialog?.close();
    root.querySelectorAll('[data-fragment-open]').forEach((button) => button.addEventListener('click',() => {
      if (!fragmentDialog || !fragmentImage) return;
      fragmentImage.src = button.dataset.fragmentSrc || '';
      fragmentImage.alt = button.dataset.fragmentCaption || 'Fragment de la Maison OrienX';
      if (fragmentCopy) fragmentCopy.textContent = button.dataset.fragmentCaption || '';
      fragmentDialog.showModal();
    }));
    root.querySelector('[data-fragment-close]')?.addEventListener('click',closeFragment);
    fragmentDialog?.addEventListener('click',(event) => { if (event.target === fragmentDialog) closeFragment(); });
    fragmentDialog?.addEventListener('cancel',(event) => { event.preventDefault(); closeFragment(); });

    if (!reduced && window.matchMedia('(pointer:fine)').matches) {
      const magnetic = root.querySelector('[data-maison-magnetic]');
      magnetic?.addEventListener('pointermove',(event) => {
        const rect = magnetic.getBoundingClientRect();
        magnetic.style.setProperty('--mag-x',`${(event.clientX - rect.left - rect.width / 2) / 9}px`);
        magnetic.style.setProperty('--mag-y',`${(event.clientY - rect.top - rect.height / 2) / 9}px`);
      });
      magnetic?.addEventListener('pointerleave',() => {
        magnetic.style.setProperty('--mag-x','0px');
        magnetic.style.setProperty('--mag-y','0px');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-email-popup"]) return;
  try {
    
  const initOrienxEmailPopup = () => {
    const dialog = document.querySelector('[data-ox-letter]');
    if (!dialog || !dialog.showModal) return;
    const frequencyKey = 'ox_letter_frequency_v3';
    const subscribedKey = 'ox_letter_subscribed_v1';
    const returningKey = 'ox_letter_form_return_v1';
    const deadlineKey = 'ox_letter_show_after_v1';
    const seenJourneyKey = 'ox_letter_seen_journey_v1';
    const image = dialog.querySelector('.ox-letter__image');
    const mobileImageSource = dialog.querySelector('.ox-letter__picture source[data-srcset]');
    const form = dialog.querySelector('form');
    const success = dialog.querySelector('[data-ox-letter-success]');
    const error = dialog.querySelector('[data-ox-letter-error]');
    let opened = false;
    let intentionalSubmit = false;
    const getStored = (key) => { try { return localStorage.getItem(key); } catch (_) { return null; } };
    const setStored = (key, value) => { try { localStorage.setItem(key, value); } catch (_) {} };
    const getSession = (key) => { try { return sessionStorage.getItem(key); } catch (_) { return null; } };
    const setSession = (key, value) => { try { sessionStorage.setItem(key, value); } catch (_) {} };
    const clearSession = (key) => { try { sessionStorage.removeItem(key); } catch (_) {} };
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const afterLoad = async () => {
      if (document.readyState === 'complete') return;
      const fullLoad = new Promise((resolve) => window.addEventListener('load', resolve, { once: true }));
      const visibleContent = (async () => {
        if (document.readyState === 'loading') await new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
        const visibleImages = [...document.images].filter((item) => {
          const rect = item.getBoundingClientRect();
          return rect.top < innerHeight && rect.bottom > 0;
        });
        const imageReady = visibleImages.map((item) => item.complete ? Promise.resolve() : new Promise((resolve) => {
          item.addEventListener('load', resolve, { once: true });
          item.addEventListener('error', resolve, { once: true });
        }));
        await Promise.race([Promise.all(imageReady), wait(12000)]);
      })();
      await Promise.race([fullLoad, visibleContent]);
    };
    const readFrequency = () => {
      let saved;
      try { saved = JSON.parse(getStored(frequencyKey) || '{}') || {}; } catch (_) { saved = {}; }
      const state = { closes: Math.max(0, Math.min(3, Number(saved.closes) || 0)), pauseUntil: Number(saved.pauseUntil) || 0 };
      if (state.pauseUntil && state.pauseUntil <= Date.now()) {
        const reset = { closes: 0, pauseUntil: 0 };
        setStored(frequencyKey, JSON.stringify(reset));
        return reset;
      }
      return state;
    };
    const suppressed = () => getStored(subscribedKey) === '1' || readFrequency().pauseUntil > Date.now();
    const recordClose = () => {
      const state = readFrequency();
      const closes = Math.min(3, state.closes + 1);
      setStored(frequencyKey, JSON.stringify({ closes, pauseUntil: closes === 3 ? Date.now() + 7 * 24 * 60 * 60 * 1000 : 0 }));
    };
    const privacyShowing = () => {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function' && window.Shopify.customerPrivacy.shouldShowBanner()) return true;
      return Array.from(document.querySelectorAll('#shopify-pc__banner, #shopify-privacy-banner, .shopify-pc__banner, #shopify-pc__prefs__dialog')).some((element) => element.getClientRects().length > 0);
    };
    const invitationDelay = Math.max(Number(dialog.dataset.delay) || 0, 3000);
    let cartOpening = false;
    let resumeAfterShopping = 0;
    // The custom cart is not a native dialog. Cover its request and open states.
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('[data-ox-cart-open]')) cartOpening = true;
    }, true);
    document.addEventListener('ox:cart-toggle', (event) => {
      cartOpening = false;
      if (event.detail?.open === false) {
        resumeAfterShopping = Date.now() + invitationDelay;
        setSession(deadlineKey, String(resumeAfterShopping));
      }
    });
    const navigationInProgress = () =>
      document.documentElement.matches('.ox-menu-open, .ox-search-open') ||
      !!document.querySelector('[data-ox-header].is-overlay-open');
    let navigationWasOpen = navigationInProgress();
    const navigationObserver = new MutationObserver(() => {
      const navigationOpen = navigationInProgress();
      if (navigationWasOpen && !navigationOpen) {
        resumeAfterShopping = Date.now() + invitationDelay;
        setSession(deadlineKey, String(resumeAfterShopping));
      }
      navigationWasOpen = navigationOpen;
    });
    const shoppingInProgress = () => cartOpening ||
      navigationInProgress() ||
      document.documentElement.classList.contains('ox-cart-open') ||
      /\/cart\/?$/.test(window.location.pathname) ||
      !!document.querySelector('[data-ox-product-form] [aria-busy="true"]');
    const readyForInvitation = () => !document.documentElement.classList.contains('orienx-entry-pending') &&
      !privacyShowing() && !shoppingInProgress() && Date.now() >= resumeAfterShopping &&
      !document.querySelector('dialog[open]:not(.ox-letter)');
    const loadImage = () => new Promise((resolve) => {
      if (!image || !image.dataset.src) { resolve(); return; }
      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', resolve, { once: true });
      if (mobileImageSource) {
        mobileImageSource.srcset = mobileImageSource.dataset.srcset;
        mobileImageSource.removeAttribute('data-srcset');
      }
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
      if (image.complete) resolve();
    });
    const open = () => { if (!opened && !dialog.open) { opened = true; navigationObserver.disconnect(); setSession(seenJourneyKey, '1'); clearSession(deadlineKey); dialog.showModal(); dialog.focus({ preventScroll: true }); } };
    dialog.querySelectorAll('[data-ox-letter-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { if (!intentionalSubmit && !success) recordClose(); });
    form?.addEventListener('submit', () => { intentionalSubmit = true; setSession(returningKey, '1'); });
    const returning = getSession(returningKey) === '1';
    if (returning) clearSession(returningKey);
    if (returning && success) setStored(subscribedKey, '1');
    let fromAnotherPageOnSite = false;
    try { fromAnotherPageOnSite = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (_) {}
    const navigationType = performance.getEntriesByType('navigation')[0]?.type;
    if (!fromAnotherPageOnSite || navigationType === 'reload') {
      clearSession(seenJourneyKey);
      clearSession(deadlineKey);
    }
    if (!returning && (suppressed() || getSession(seenJourneyKey) === '1')) return;
    navigationObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    const navigationHeader = document.querySelector('[data-ox-header]');
    if (navigationHeader) navigationObserver.observe(navigationHeader, { attributes: true, attributeFilter: ['class'] });
    let showAfter = Number(getSession(deadlineKey));
    if (!returning && (!showAfter || !Number.isFinite(showAfter))) {
      showAfter = Date.now() + invitationDelay;
      setSession(deadlineKey, String(showAfter));
    }
    afterLoad().then(async () => {
      if (document.fonts && document.fonts.ready) await Promise.race([document.fonts.ready, wait(2500)]);
      if (!returning) await wait(Math.max(showAfter - Date.now(), 0));
      while (!readyForInvitation()) await wait(1000);
      if (!returning && (suppressed() || getSession(seenJourneyKey) === '1')) return;
      await loadImage();
      // Consent settings may open while the invitation image is loading.
      while (!readyForInvitation()) await wait(1000);
      if (returning && !success && !error) return;
      if (success && !returning) success.hidden = true;
      if (returning && success) {
        form.querySelectorAll('input,button').forEach((control) => { control.disabled = true; });
      }
      open();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOrienxEmailPopup, { once: true });
  else initOrienxEmailPopup();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ox-header]');
    if (!root || root.dataset.ready === 'true') return;
    window.__orienxHeaderCleanup?.();
    root.dataset.ready = 'true';

    const events = new AbortController();
    const { signal } = events;
    const triggers = root.querySelectorAll('[data-ox-menu-trigger]');
    const panels = root.querySelectorAll('[data-ox-menu]');
    const selectors = [...root.querySelectorAll('[data-ox-selector]')];
    const mobileToggle = root.querySelector('[data-ox-mobile-toggle]');
    const mobileMenu = root.querySelector('[data-ox-mobile-menu]');
    const mobilePanel = root.querySelector('[data-ox-mobile-panel]');
    const mobileCloseControls = root.querySelectorAll('[data-ox-mobile-close]');
    const search = root.querySelector('[data-ox-search-dialog]');
    const searchInput = search?.querySelector('input[type="search"]');
    const searchResults = search?.querySelector('[data-ox-search-results]');
    const searchStarter = searchResults?.innerHTML || '';
    let searchTimer = 0;
    let searchRequest = null;
    const supportsZoneObserver = 'IntersectionObserver' in window;
    let zones = [];
    let zoneObserver = null;
    let surfaceFrame = 0;
    let mobileCloseTimer = 0;
    let mobileOpenFrame = 0;
    let mobileReturnFocus = null;

    const validTone = (value) => value === 'light' || value === 'dark';
    const getHeaderProbeY = () => Math.max(0, Math.min(root.getBoundingClientRect().bottom - 1, window.innerHeight - 1));
    const getActiveHeaderZone = () => {
      const probeY = getHeaderProbeY();
      return zones.find((zone) => {
        const rect = zone.getBoundingClientRect();
        return rect.top <= probeY && rect.bottom > probeY && validTone(zone.dataset.oxHeaderTone);
      });
    };
    const hasOpenOverlay = () =>
      [...panels].some((panel) => !panel.hidden) ||
      Boolean(mobileMenu && !mobileMenu.hidden) ||
      Boolean(search?.open) ||
      document.documentElement.classList.contains('ox-search-open') ||
      selectors.some((selector) => selector.open) ||
      document.documentElement.classList.contains('ox-cart-open');
    const applyHeaderSurface = () => {
      const overlayOpen = hasOpenOverlay();
      const activeZone = supportsZoneObserver && !overlayOpen ? getActiveHeaderZone() : null;
      root.classList.remove('is-solid','is-transparent','is-tone-light','is-tone-dark');
      root.classList.toggle('is-overlay-open', overlayOpen);
      root.classList.toggle('is-scrolled', window.scrollY > 16);
      if (!activeZone) {
        root.classList.add('is-solid');
        return;
      }
      root.classList.add('is-transparent', `is-tone-${activeZone.dataset.oxHeaderTone}`);
    };
    const scheduleHeaderSurface = () => {
      if (surfaceFrame) return;
      surfaceFrame = requestAnimationFrame(() => {
        surfaceFrame = 0;
        applyHeaderSurface();
      });
    };
    const setSurfacePreview = (active) => {
      root.classList.toggle('is-surface-preview', active);
    };
    const refreshHeaderZones = () => {
      zoneObserver?.disconnect();
      zones = supportsZoneObserver
        ? [...document.querySelectorAll('[data-ox-header-zone="transparent"]')].filter((zone) => validTone(zone.dataset.oxHeaderTone))
        : [];
      if (supportsZoneObserver) {
        zoneObserver = new IntersectionObserver(scheduleHeaderSurface);
        zones.forEach((zone) => zoneObserver.observe(zone));
      }
      scheduleHeaderSurface();
    };

    const showMegaChildren = (panel, key) => {
      if (!panel || !key) return;
      panel.querySelectorAll('[data-ox-mega-children]').forEach((group) => {
        group.hidden = group.dataset.oxMegaChildren !== key;
      });
      panel.querySelectorAll('[data-ox-mega-target]').forEach((target) => {
        target.setAttribute('aria-expanded', String(target.dataset.oxMegaTarget === key));
      });
    };
    panels.forEach((panel) => {
      panel.querySelectorAll('[data-ox-mega-target]').forEach((target) => {
        const reveal = () => showMegaChildren(panel, target.dataset.oxMegaTarget);
        target.addEventListener('pointerenter', reveal, { signal });
        target.addEventListener('focus', reveal, { signal });
      });
    });
    const closeMega = () => {
      panels.forEach((panel) => {
        panel.hidden = true;
        panel.querySelectorAll('[data-ox-mega-children]').forEach((group) => group.hidden = true);
        panel.querySelectorAll('[data-ox-mega-target]').forEach((target) => target.setAttribute('aria-expanded', 'false'));
      });
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded','false'));
      scheduleHeaderSurface();
    };
    const openMega = (trigger) => {
      const panel = root.querySelector(`[data-ox-menu="${trigger.dataset.oxMenuTrigger}"]`);
      closeMega();
      if (panel) {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded','true');
      }
      scheduleHeaderSurface();
    };
    triggers.forEach((trigger) => {
      trigger.addEventListener('pointerenter', () => {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) openMega(trigger);
      }, { signal });
      trigger.addEventListener('focus', () => openMega(trigger), { signal });
    });
    const closeSelectors = (exception = null) => {
      selectors.forEach((selector) => {
        if (selector === exception) return;
        selector.removeAttribute('open');
        selector.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });
      scheduleHeaderSurface();
    };
    selectors.forEach((selector) => selector.addEventListener('toggle', () => {
      selector.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(selector.open));
      if (selector.open) closeSelectors(selector);
      else scheduleHeaderSurface();
    }, { signal }));

    const mobileTransitionDuration = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 480;
    const setMobileToggleState = (open) => {
      mobileToggle?.setAttribute('aria-expanded', String(open));
      const label = mobileToggle?.querySelector('.ox-header__sr-only');
      if (label) label.textContent = open ? 'Fermer' : 'Menu';
    };
    const mobileFocusable = () => mobilePanel
      ? [...mobilePanel.querySelectorAll('a[href],button:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')]
          .filter((element) => !element.hidden && element.getClientRects().length)
      : [];
    const openMobile = () => {
      if (!mobileMenu || !mobileToggle) return;
      closeMega();
      closeSelectors();
      if (mobileCloseTimer) window.clearTimeout(mobileCloseTimer);
      if (mobileOpenFrame) cancelAnimationFrame(mobileOpenFrame);
      mobileReturnFocus = document.activeElement;
      mobileMenu.hidden = false;
      mobileMenu.setAttribute('aria-hidden','false');
      setMobileToggleState(true);
      document.documentElement.classList.add('ox-menu-open');
      mobileOpenFrame = requestAnimationFrame(() => {
        mobileOpenFrame = requestAnimationFrame(() => {
          mobileOpenFrame = 0;
          if (!mobileMenu.hidden) mobileMenu.classList.add('is-open');
        });
      });
      window.setTimeout(() => mobilePanel?.focus({ preventScroll: true }), mobileTransitionDuration() ? 110 : 0);
      scheduleHeaderSurface();
    };
    const closeMobile = ({ restoreFocus = true, immediate = false } = {}) => {
      if (!mobileMenu || mobileMenu.hidden) return;
      if (mobileOpenFrame) {
        cancelAnimationFrame(mobileOpenFrame);
        mobileOpenFrame = 0;
      }
      if (mobileCloseTimer) window.clearTimeout(mobileCloseTimer);
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden','true');
      setMobileToggleState(false);
      document.documentElement.classList.remove('ox-menu-open');
      const finish = () => {
        mobileCloseTimer = 0;
        if (!mobileMenu.classList.contains('is-open')) mobileMenu.hidden = true;
        if (restoreFocus && mobileReturnFocus instanceof HTMLElement) mobileReturnFocus.focus();
        mobileReturnFocus = null;
        setSurfacePreview(false);
        scheduleHeaderSurface();
      };
      const delay = immediate ? 0 : mobileTransitionDuration();
      if (delay) mobileCloseTimer = window.setTimeout(finish, delay);
      else finish();
      scheduleHeaderSurface();
    };

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMega();
        closeSelectors();
        closeMobile();
        return;
      }
      if (event.key === 'Tab' && mobileMenu?.classList.contains('is-open')) {
        const focusable = mobileFocusable();
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === mobilePanel || !mobilePanel?.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === mobilePanel)) {
          event.preventDefault();
          first.focus();
        }
      }
    }, { signal });
    root.addEventListener('pointerenter', () => setSurfacePreview(true), { signal });
    root.addEventListener('pointerleave', () => {
      setSurfacePreview(false);
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) closeMega();
    }, { signal });
    root.addEventListener('focusin', () => setSurfacePreview(true), { signal });
    root.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!root.contains(document.activeElement)) setSurfacePreview(false);
      });
    }, { signal });
    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeMega();
      if (!selectors.some((selector) => selector.contains(event.target))) closeSelectors();
    }, { signal });

    mobileToggle?.addEventListener('click', () => {
      if (mobileMenu?.hidden) openMobile();
      else closeMobile();
    }, { signal });
    mobileCloseControls.forEach((control) => control.addEventListener('click', () => closeMobile(), { signal }));

    root.querySelector('[data-ox-search-open]')?.addEventListener('click', () => {
      search?.showModal();
      searchInput?.focus();
      scheduleHeaderSurface();
    }, { signal });
    root.querySelector('[data-ox-search-close]')?.addEventListener('click', () => {
      search?.close();
      scheduleHeaderSurface();
    }, { signal });
    search?.addEventListener('click', (event) => {
      if (event.target === search) search.close();
      scheduleHeaderSurface();
    }, { signal });
    search?.addEventListener('close', scheduleHeaderSurface, { signal });

    const renderSearchProducts = (products, query) => {
      if (!searchResults) return;
      searchResults.replaceChildren();

      if (!products.length) {
        const empty = document.createElement('p');
        empty.className = 'ox-search__empty';
        empty.textContent = search.dataset.oxNoResults.replace('{query}', query);
        searchResults.append(empty);
        return;
      }

      const head = document.createElement('div');
      head.className = 'ox-search__result-head';
      const label = document.createElement('span');
      label.textContent = search.dataset.oxProducts;
      const count = document.createElement('span');
      count.textContent = `${products.length} ${products.length === 1 ? search.dataset.oxResultOne : search.dataset.oxResultOther}`;
      head.append(label, count);

      const grid = document.createElement('div');
      grid.className = 'ox-search__grid';
      products.forEach((product) => {
        const card = document.createElement('a');
        card.className = 'ox-search__product';
        card.href = product.url;

        const handle = product.handle || (product.url ? new URL(product.url, location.origin).pathname.split('/').filter(Boolean).pop() : '');
        const localizedTitle = (handle && search.getAttribute(`data-ox-title-${handle}`)) || product.title || '';
        const imageUrl = product.image?.url || product.featured_image?.url || product.featured_image || product.image;
        if (typeof imageUrl === 'string' && imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = localizedTitle;
          image.width = 152;
          image.height = 152;
          image.loading = 'lazy';
          card.append(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'ox-search__placeholder';
          placeholder.setAttribute('aria-hidden', 'true');
          card.append(placeholder);
        }

        const copy = document.createElement('span');
        copy.className = 'ox-search__product-copy';
        const title = document.createElement('span');
        title.className = 'ox-search__product-title';
        title.textContent = localizedTitle;
        copy.append(title);
        if (product.price) {
          const price = document.createElement('span');
          price.className = 'ox-search__product-price';
          const numericPrice = Number(product.price);
          price.textContent = Number.isFinite(numericPrice)
            ? new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(numericPrice)
            : product.price;
          copy.append(price);
        }
        card.append(copy);
        grid.append(card);
      });

      const all = document.createElement('a');
      all.className = 'ox-search__all';
      all.href = `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(query)}&type=product`;
      const allLabel = document.createElement('span');
      allLabel.textContent = search.dataset.oxViewAll;
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      all.append(allLabel, arrow);
      searchResults.append(head, grid, all);
    };

    searchInput?.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      searchRequest?.abort();
      const query = searchInput.value.trim();
      if (query.length < 2) {
        if (searchResults) searchResults.innerHTML = searchStarter;
        return;
      }

      searchTimer = window.setTimeout(async () => {
        searchRequest = new AbortController();
        if (searchResults) { const note = document.createElement('p'); note.className = 'ox-search__loading'; note.textContent = search.dataset.oxLoading; searchResults.replaceChildren(note); }
        try {
          const endpoint = search?.dataset.predictiveSearchUrl || '/search/suggest';
          const url = `${endpoint}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
          const response = await fetch(url, { signal: searchRequest.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
          const payload = await response.json();
          renderSearchProducts(payload.resources?.results?.products || [], query);
        } catch (error) {
          if (error.name === 'AbortError') return;
          if (searchResults) { const note = document.createElement('p'); note.className = 'ox-search__empty'; note.textContent = search.dataset.oxUnavailable; searchResults.replaceChildren(note); }
        }
      }, 220);
    }, { signal });

    window.addEventListener('scroll', scheduleHeaderSurface, { passive: true, signal });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1180) closeMobile({ restoreFocus: false, immediate: true });
      refreshHeaderZones();
    }, { passive: true, signal });
    window.addEventListener('load', scheduleHeaderSurface, { once: true, signal });
    document.addEventListener('shopify:section:load', refreshHeaderZones, { signal });
    document.addEventListener('ox:cart-toggle', (event) => {
      if (event.detail?.open) {
        closeMobile({ restoreFocus: false, immediate: true });
        closeMega();
        closeSelectors();
      }
      scheduleHeaderSurface();
    }, { signal });
    document.addEventListener('ox:mobile-search-open', () => {
      closeMobile({ restoreFocus: false, immediate: true });
      closeMega();
      closeSelectors();
      scheduleHeaderSurface();
    }, { signal });
    document.addEventListener('ox:mobile-search-close', scheduleHeaderSurface, { signal });
    window.__orienxHeaderCleanup = () => {
      events.abort();
      zoneObserver?.disconnect();
      if (surfaceFrame) cancelAnimationFrame(surfaceFrame);
      if (mobileOpenFrame) cancelAnimationFrame(mobileOpenFrame);
      if (mobileCloseTimer) window.clearTimeout(mobileCloseTimer);
      document.documentElement.classList.remove('ox-menu-open');
    };
    refreshHeaderZones();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-product-reviews"] && !Shopify.designMode) return;
  try {
    
  function initOrienxReviews(root) {
    root.querySelectorAll('[data-ox-reviews]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const button = section.querySelector('[data-ox-review-write]');
      const panel = section.querySelector('[data-ox-review-panel]');
      button.setAttribute('aria-expanded', String(!panel.hidden));
      button.addEventListener('click', () => {
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', String(!panel.hidden));
        if (!panel.hidden) panel.querySelector('input:not([type="hidden"]), [role="status"]')?.focus();
      });
      const sort = section.querySelector('[data-ox-review-sort]');
      const list = section.querySelector('[data-ox-review-list]');
      const items = [...list.querySelectorAll('[data-ox-review-item]')];
      function applySort() {
        const value = sort.value;
        items.sort((a,b) => value === 'highest' ? Number(b.dataset.rating) - Number(a.dataset.rating) : value === 'lowest' ? Number(a.dataset.rating) - Number(b.dataset.rating) : (Number(b.dataset.date) || 0) - (Number(a.dataset.date) || 0));
        items.forEach(item => list.appendChild(item));
      }
      sort.addEventListener('change', applySort);
      applySort();
    });
  }
  initOrienxReviews(document);
  document.addEventListener('shopify:section:load', event => initOrienxReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-selected-pieces"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const init=(root)=>{
      if(!root||root.dataset.oxSelectedReady==='true')return;
      root.dataset.oxSelectedReady='true';
      const viewport=root.querySelector('[data-ox-selected-viewport]');
      const track=root.querySelector('[data-ox-selected-track]');
      const previous=root.querySelector('[data-ox-selected-prev]');
      const next=root.querySelector('[data-ox-selected-next]');
      const status=root.querySelector('[data-ox-selected-status]');
      const cards=[...root.querySelectorAll('[data-ox-selected-card]')];
      if(!viewport||!track||cards.length<2)return;
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const cloneCount=Math.min(3,cards.length);
      cards.slice(0,cloneCount).forEach(card=>{
        const clone=card.cloneNode(true);
        clone.dataset.oxSelectedClone='true';
        clone.removeAttribute('data-ox-selected-card');
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden','true');
        if(clone.matches('a,button,[tabindex]'))clone.setAttribute('tabindex','-1');
        clone.querySelectorAll('a,button,[tabindex]').forEach(node=>node.setAttribute('tabindex','-1'));
        track.appendChild(clone);
      });
      let timer=0;
      let scrollFrame=0;
      let settleTimer=0;
      let targetIndex=null;
      let dragging=false;
      let dragged=false;
      let dragStartX=0;
      let dragStartScroll=0;
      let dragPointerId=null;
      const dragThreshold=10;
      const step=()=>{
        const gap=parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap)||0;
        return cards[0].getBoundingClientRect().width+gap;
      };
      const updateStatus=()=>{
        const distance=step();
        const active=distance?Math.round(viewport.scrollLeft/distance)%cards.length:0;
        if(status)status.textContent=`${String(active+1).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}`;
      };
      const normalize=()=>{
        const distance=step();
        updateStatus();
        window.clearTimeout(settleTimer);
        settleTimer=window.setTimeout(()=>{
          if(distance&&viewport.scrollLeft>=cards.length*distance-1){
            viewport.scrollTo({left:0,behavior:'auto'});
          }
          targetIndex=null;
          updateStatus();
        },180);
      };
      const move=(direction)=>{
        const distance=step();
        if(!distance)return;
        let current=targetIndex===null?Math.round(viewport.scrollLeft/distance):targetIndex;
        if(current>=cards.length){
          viewport.scrollTo({left:0,behavior:'auto'});
          current=0;
        }
        let target=current+direction;
        if(target<0){
          viewport.scrollTo({left:cards.length*distance,behavior:'auto'});
          target=cards.length-1;
        }
        targetIndex=target;
        viewport.scrollTo({left:target*distance,behavior:reduced?'auto':'smooth'});
      };
      const stopAutoplay=()=>{if(timer){window.clearInterval(timer);timer=0}};
      const startAutoplay=()=>{
        stopAutoplay();
        if(reduced||document.hidden)return;
        timer=window.setInterval(()=>move(1),4200);
      };
      previous?.addEventListener('click',()=>{stopAutoplay();move(-1);startAutoplay()});
      next?.addEventListener('click',()=>{stopAutoplay();move(1);startAutoplay()});
      const releasePointerFocus=button=>{
        button?.addEventListener('pointerup',()=>button.blur());
        button?.addEventListener('pointercancel',()=>button.blur());
      };
      releasePointerFocus(previous);
      releasePointerFocus(next);
      root.addEventListener('focusin',stopAutoplay);
      root.addEventListener('focusout',event=>{if(!root.contains(event.relatedTarget))startAutoplay()});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)stopAutoplay();else startAutoplay()});
      viewport.addEventListener('scroll',()=>{
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame=window.requestAnimationFrame(normalize);
      },{passive:true});
      viewport.addEventListener('pointerdown',event=>{
        stopAutoplay();
        dragged=false;
        if(event.pointerType!=='mouse'||event.button!==0)return;
        dragging=true;
        dragPointerId=event.pointerId;
        dragStartX=event.clientX;
        dragStartScroll=viewport.scrollLeft;
      });
      viewport.addEventListener('pointermove',event=>{
        if(!dragging)return;
        const delta=event.clientX-dragStartX;
        if(Math.abs(delta)<dragThreshold)return;
        if(!dragged){dragged=true;viewport.setPointerCapture?.(event.pointerId)}
        viewport.scrollLeft=dragStartScroll-delta;
      });
      const finishDrag=()=>{
        if(dragPointerId!==null&&viewport.hasPointerCapture?.(dragPointerId))viewport.releasePointerCapture?.(dragPointerId);
        dragging=false;
        dragPointerId=null;
        startAutoplay();
      };
      viewport.addEventListener('pointerup',finishDrag);
      viewport.addEventListener('pointercancel',finishDrag);
      viewport.addEventListener('click',event=>{if(dragged){event.preventDefault();event.stopPropagation();dragged=false}},true);
      if(!reduced&&'IntersectionObserver'in window){
        const observer=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{
            if(entry.isIntersecting&&entry.intersectionRatio>=.12){
              root.classList.remove('is-reveal-edge');
              root.classList.add('is-visible');startAutoplay();return;
            }
            if(entry.isIntersecting&&entry.intersectionRatio>0){
              if(entry.intersectionRatio<=.025&&root.classList.contains('is-visible'))root.classList.add('is-reveal-edge');
              return;
            }
            root.classList.remove('is-visible','is-reveal-edge');
            const distance=window.matchMedia('(max-width:600px)').matches?8:12;
            root.style.setProperty('--ox-selected-reveal-y',`${entry.boundingClientRect.bottom<=0?-distance:distance}px`);
            stopAutoplay();
          });
        },{threshold:[0,.025,.12],rootMargin:'0px'});
        observer.observe(root);
      }else{root.classList.add('is-visible');startAutoplay()}
      if(!reduced&&window.matchMedia('(pointer:fine)').matches){cards.forEach(card=>{card.addEventListener('pointermove',event=>{const r=card.getBoundingClientRect();const x=(event.clientX-r.left)/r.width-.5;const y=(event.clientY-r.top)/r.height-.5;card.style.setProperty('--ox-card-x',`${x*-7}px`);card.style.setProperty('--ox-card-y',`${y*-7}px`)});card.addEventListener('pointerleave',()=>{card.style.setProperty('--ox-card-x','0px');card.style.setProperty('--ox-card-y','0px')})})}
      updateStatus();
    };
    const initAll=(scope=document)=>{scope.querySelectorAll?.('[data-ox-selected-pieces]').forEach(init);if(scope.matches?.('[data-ox-selected-pieces]'))init(scope)};
    initAll();document.addEventListener('shopify:section:load',event=>initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-stories-page"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const root=document.querySelector('[data-ox-stories]');
    if(!root||root.dataset.ready==='true')return;
    root.dataset.ready='true';
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals=root.querySelectorAll('[data-story-reveal]');
    if(!reduced&&'IntersectionObserver'in window){
      root.classList.add('ox-story-motion');
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;entry.target.classList.add('is-visible');observer.unobserve(entry.target)}),{threshold:.08,rootMargin:'0px 0px -5%'});
      reveals.forEach(item=>observer.observe(item));
    }else reveals.forEach(item=>item.classList.add('is-visible'));
    const dialog=root.querySelector('[data-story-dialog]');
    const player=root.querySelector('[data-story-player]');
    const close=()=>{player?.pause();dialog?.close()};
    root.querySelectorAll('[data-story-open]').forEach(button=>button.addEventListener('click',()=>{if(!dialog||!player||!button.dataset.storySrc)return;player.src=button.dataset.storySrc;player.poster=button.dataset.storyPoster||'';dialog.showModal();player.play().catch(()=>{})}));
    root.querySelector('[data-story-close]')?.addEventListener('click',close);
    dialog?.addEventListener('click',event=>{if(event.target===dialog)close()});
    dialog?.addEventListener('cancel',event=>{event.preventDefault();close()});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-workshops-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const markVisible = (items) => items.forEach((item) => item && item.classList.add('is-visible'));
    const afterPaint = (callback) => requestAnimationFrame(() => {
      requestAnimationFrame(callback);
    });

    const waitForImage = (image) => {
      if (!image) return Promise.resolve();
      if (image.complete) {
        if (typeof image.decode === 'function') return image.decode().catch(() => undefined);
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        const done = () => resolve();
        image.addEventListener('load', done, { once: true });
        image.addEventListener('error', done, { once: true });
      });
    };

    const replayHero = (root) => {
      const heroImage = root.querySelector('.ox-workshops__hero-media>img[data-ox-workshops-reveal]');
      const heroCopy = root.querySelector('[data-ox-workshops-hero-copy]');
      const heroItems = [heroImage, heroCopy].filter(Boolean);
      if (!heroItems.length) return;

      const replayToken = String((Number(root.dataset.oxHeroReplay || 0) + 1));
      root.dataset.oxHeroReplay = replayToken;
      root.classList.add('ox-workshops--reveal-ready');
      heroItems.forEach((item) => item.classList.remove('is-visible'));

      if (reduceMotion()) {
        markVisible(heroItems);
        return;
      }

      afterPaint(() => {
        if (root.dataset.oxHeroReplay !== replayToken) return;
        markVisible([heroCopy]);
      });

      waitForImage(heroImage).then(() => {
        if (root.dataset.oxHeroReplay !== replayToken) return;
        afterPaint(() => {
          if (root.dataset.oxHeroReplay !== replayToken) return;
          markVisible([heroImage]);
        });
      });
    };

    const initialiseWorkshopReveals = () => {
      document.querySelectorAll('.ox-workshops:not([data-ox-reveal-bound])').forEach((root) => {
        root.setAttribute('data-ox-reveal-bound', 'true');
        root.classList.add('ox-workshops--reveal-ready');
        const items = Array.from(root.querySelectorAll('[data-ox-workshops-reveal]'));
        const heroImage = root.querySelector('.ox-workshops__hero-media>img[data-ox-workshops-reveal]');
        const heroCopy = root.querySelector('[data-ox-workshops-hero-copy]');

        if (reduceMotion() || !('IntersectionObserver' in window)) {
          markVisible([...items, heroCopy]);
          return;
        }

        replayHero(root);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseWorkshopReveals, { once: true });
    else initialiseWorkshopReveals();
    document.addEventListener('shopify:section:load', initialiseWorkshopReveals);
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      document.querySelectorAll('.ox-workshops').forEach((root) => replayHero(root));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
